'use client';

import {useMemo, useState} from 'react';
import {Range} from '../../../../../../components/design-system';
import FilterModal from './FilterModal';

import {useTranslations} from 'next-intl';
import useShop from '../../../../../../stores/shop/useContext';
import useFilters from '../hooks/useFilters';

interface Range {
  priceMin: number;
  priceMax: number;
}

export default function FilterPrice() {
  const t = useTranslations('shop');

  const {facets} = useShop((s) => s);
  const {filters, set} = useFilters();

  const prices = useMemo(() => {
    return [...(facets.prices || [])]
      .sort((a, b) => a.price - b.price)
      .map((p, index) =>
        index === facets.prices.length - 1
          ? Math.ceil(p.price)
          : Math.floor(p.price),
      );
  }, [facets.prices]);
  const [selected, setSelected] = useState<Range>({
    priceMin: filters.priceMin || 0,
    priceMax: filters.priceMax || prices[prices.length - 1],
  });

  function handleChange([min, max]: number[]) {
    setSelected({
      priceMin: min || 0,
      priceMax: max || prices[prices.length - 1],
    });
  }

  function handleApply() {
    set({priceMin: selected.priceMin, priceMax: selected.priceMax});
  }

  return (
    <FilterModal
      label={t('filter.price.title')}
      appliedValue={
        filters.priceMin || filters.priceMax
          ? t('filter.price.fromTo', {
              from: filters.priceMin,
              to: filters.priceMax,
            })
          : undefined
      }
      onApply={() => handleApply()}
    >
      <form className="px-4 mt-4">
        <Range
          min={0}
          max={prices[prices.length - 1]}
          value={[
            selected.priceMin || 0,
            selected.priceMax || prices[prices.length - 1],
          ]}
          onChange={handleChange}
        />
      </form>
    </FilterModal>
  );
}
